import React, {Component} from 'react'
import {observer} from 'mobx-react'

import Hint from '../struct/Hint'

const GENERAL_ERROR_MESSAGE = 'Неправильный формат (например, "3-5")'

const getPartError = part => {
    if (part !== part.trim()) {
        return 'Лишние пробелы'
    }

    const days_int = part

    if (Number.isNaN(days_int)) {
        return `Неправильный формат "${days_int}". Пример: "3-5"`
    }

    if (days_int < 0) {
        return `Отрицательное значение "${days_int}"`
    }
}

@observer export default class DeliveryDaysValidationError extends Component {
    render() {
        const error = this.getCostError()


        if (error) {
            return (
                <Hint error>{error}</Hint>
            )
        } else {
            return null
        }
    }

    getCostError() {
        /** @type {String} */
        const days = this.props.days

        if (days.trim() === '') {
            return null
        }

        if (days.match(/^[-0-9]+$/) === null) {
            return GENERAL_ERROR_MESSAGE
        }

        const cost_parts = days.trim().split('-')

        if (cost_parts.length > 2) {
            return GENERAL_ERROR_MESSAGE
        }

        if (cost_parts.length === 1) {
            return getPartError(cost_parts[0])
        }

        if (cost_parts.length === 2) {
            if (cost_parts[0] === '' || cost_parts[1] === '') {
                return GENERAL_ERROR_MESSAGE
            }

            const part_1_error = getPartError(cost_parts[0])
            if (part_1_error) {
                return part_1_error
            }

            const part_2_error = getPartError(cost_parts[1])
            if (part_2_error) {
                return part_2_error
            }

            const from = parseInt(cost_parts[0])
            const to = parseInt(cost_parts[1])

            if (from >= to) {
                return 'Начало диапазона должно быть меньше конца (например, "3-5")'
            }

            if (to - from > 2) {
                return `Разница не должна быть больше двух дней (например, "${to - 2}-${to}")`
            }
        }

        return null
    }
}